export function isMagazineArticle(item) {
    return item?.type === "MagazineArticle";
}
export function isQuarterPageArticle(item) {
    return item?.type === "QuarterPageArticle";
}
export function isHalfPageArticle(item) {
    return item?.type === "HalfPageArticle";
}
export function isFullPageArticle(item) {
    return item?.type === "FullPageArticle";
}
export function isSpotlightArticle(item) {
    return item?.type === "SpotlightArticle";
}
//# sourceMappingURL=magazine-article.js.map